import React, {useEffect, useState} from "react";
import { Input } from 'antd';
import {Form} from 'react-bootstrap'
import {EditInfoFooter} from "../../Components/Footers";
import {useNavigate} from "react-router-dom";
import usePortalService from "../../services/PortalService";
import ErrorMessage from "../../Components/Errors/ErrorMessage";

const { TextArea } = Input;

type AboutProps = {
  isBottom: boolean;
  onResize: () => void;
  handleFooter: () => void;
}

export const About = ({isBottom, onResize, handleFooter}: AboutProps) => {
  const {aboutMeInformation, addSkills, error, clearError } = usePortalService();

  const navigate = useNavigate()
  const [about, setAbout] = useState("")

  useEffect(() => {
    aboutMeInformation().then(result => {
      if (result.success) {
        setAbout(result.aboutMeProfile.aboutMe);
      }
    })
    handleFooter()
  },[])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      clearError();
      const result = await addSkills ({
        aboutMe : about
      });

      if (result.success) {
          navigate("/home");
      }
    } catch {
      // ошибка уже сохранена в error и отображается ниже
    }
  }

  return(
    <>
      <div style={{maxWidth : "410px", width: "100%"}}>
        <h2 style={{marginBottom: '12px'}}>Обо мне</h2>
        <Form.Label>Опишите свои ключевые навыки</Form.Label>
        <TextArea rows={12} value={about} onChange={e => setAbout(e.target.value)} onResize={onResize}/>
      </div>
      {error && <ErrorMessage message={error} />}
      <EditInfoFooter isBottom={isBottom} onSave={handleSave} onCancel={() => navigate("/home")}/>
    </>
  )
}